export const enum LoadingState {
    init,
    loading,
    error,
    done
}


// WEBPACK FOOTER //
// ./src/LoadingState.ts